/**
 *
 * Add Google Workspace
 *
 */

import React from 'react';

import { CloudProviders } from '@ariksa/cloud-account/api';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Form } from 'components/DataEntry/Form';
import { selectSetup } from 'containers/Setup/selectors';
import { actions as setupActions } from 'containers/Setup/slice';

import { formStyles } from '../../../../../Integrations/styles';

export const AddGoogleWorkspace = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { onboardAccount } = useSelector(selectSetup);

  const handleReset = () => {
    navigate('/setup/accounts');
  };

  const handleSubmit = data => {
    const { name, customer_id, delegation_subject } = data;

    dispatch(
      setupActions.onboardAccount({
        q: {
          cloudAccountCreateRequest: {
            name,
            cloud_type: CloudProviders.GoogleWorkspace,
            google_workspace: { customer_id, delegation_subject },
          },
        },
        onSuccess: () => navigate('/setup/accounts'),
      }),
    );
  };

  return (
    <Form
      title="Add Google Workspace"
      iconType={CloudProviders.GoogleWorkspace}
      isTitleIconFilled={false}
      schema={{
        name: {
          type: 'text',
          label: 'Connector Name',
          isRequired: true,
          autoFocus: true,
        },
        customer_id: {
          type: 'text',
          label: 'Customer ID',
          isRequired: true,
        },
        delegation_subject: {
          type: 'text',
          label: 'Impersonation User Email ID',
          isRequired: true,
        },
      }}
      styles={{ form: { ...formStyles.form } }}
      buttonOptions={{
        submit: { name: 'OK', isLoading: onboardAccount.isLoading },
        reset: {
          isVisible: true,
          onClick: handleReset,
        },
      }}
      handleSubmit={handleSubmit}
    />
  );
};
